'use client'

import { Button, Cell } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { UserBundleDiscountModel } from '@marketplace-web/bundles/items-bundle-data'

import { CREATE_BUNDLE_URL } from '../../constants/routes'
import StartBundleButtonWrapper from '../StartBundleButtonWrapper'

type Props = {
  itemUserId: number
  bundleDiscount: UserBundleDiscountModel | null
  screen: string
  itemId?: number | null
  canBuyItem?: boolean
  showStartBundleButton?: boolean
}

const BundleEntryBanner = ({
  bundleDiscount,
  itemId = null,
  itemUserId,
  screen,
  canBuyItem = false,
  showStartBundleButton = true,
}: Props) => {
  const translate = useTranslate('bundles.item')
  const startNewBundleUrl = CREATE_BUNDLE_URL(itemUserId)

  const getBundleDiscountText = () => {
    if (!bundleDiscount?.isEnabled) return translate('discounts.not_available')

    const { discounts } = bundleDiscount

    const fractions = discounts.map(discount => Number(discount.fraction))
    const biggestFraction = Math.max(...fractions)

    return translate('discounts.available', {
      discount: (biggestFraction * 100).toFixed(0),
    })
  }

  const renderStartBundleButton = () => {
    if (!showStartBundleButton) return null

    return (
      <StartBundleButtonWrapper
        url={startNewBundleUrl}
        itemIds={canBuyItem && itemId ? [itemId] : null}
        screen={screen}
      >
        {({ onClick }) => (
          <Button
            text={translate('shop_action')}
            size="medium"
            styling="filled"
            onClick={onClick}
            testId="buy-bundle-banner-shop-button"
          />
        )}
      </StartBundleButtonWrapper>
    )
  }

  return (
    <Cell
      title={translate('shop_title')}
      body={getBundleDiscountText()}
      suffix={renderStartBundleButton()}
      testId="buy-bundle-banner"
    />
  )
}

export default BundleEntryBanner
